import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=d490b650&scoped=true&"
import script from "./Introduction.vue?vue&type=script&lang=js&"
export * from "./Introduction.vue?vue&type=script&lang=js&"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=d490b650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d490b650",
  null
  
)

export default component.exports